import { memo } from "react";
import Screen, { type ScreenProps } from "ui/layouts/Screen";
import { BankingSDKRecipients as BankingSDKRecipientsComponent } from "ui/organizms/OpenBanking";

const BankingSDKRecipients = (props: ScreenProps) => (
    <Screen
        {...props}
        title='Open Banking | Recipients'
    >
        <BankingSDKRecipientsComponent />
    </Screen>

);

export default memo(BankingSDKRecipients);
